import {
    PerformanceMeasureEngine,
} from '@tencent/speed-insights';
import { BaseDsiReportService } from '@src/slide/application/service/dsi-report-service/base';
import { PcDsiBenchmarkIndexes } from '@src/slide/application/service/dsi-report-service/pc/dsi-benchmark-indexs';

export default class PcDsiReportService extends BaseDsiReportService {
    public constructor() {
        super();
        this.dsiBenchmarkIndexes = new PcDsiBenchmarkIndexes();
        this.engine = new PerformanceMeasureEngine(this.dsiBenchmarkIndexes.indexes);
        // 性能自动化, 挂载到全局
        global.speedInsights = this;
    }
}
